import { DOCTYPES } from '@/constants/doctypes.ts'
import { createDoctypeListDetailRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  detail: routeNamingSettingsDetail,
  home: routeNamingSettingsHome,
  root: routeNamingSettingsRoot,
} = createDoctypeListDetailRoutes({
  detailName: 'namingSettings',
  doctype: DOCTYPES.DOCUMENT_NAMING_SETTINGS,
  homeName: 'naming-settings-home',
  path: 'naming-settings',
  views: {
    detail: async () =>
      await import('@/components/viewsExternal/settings/namingSettings/NamingSettingsView.vue'),
    list: async () =>
      await import('@/components/viewsExternal/settings/namingSettings/NamingSettingsView.vue'),
  },
})

export { routeNamingSettingsDetail, routeNamingSettingsHome, routeNamingSettingsRoot }
